import {CanActivateFn, CanMatchFn} from '@angular/router';
import {inject} from "@angular/core";
import {UserService} from "./user.service";

export const isAdminGuard: CanActivateFn = (route, segments) => {
  return inject(UserService).isAdmin();
};
